export default __webpack_public_path__ + "static/media/Message4.ad0083c7.png";